import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const ChannelHistory = createApi({
  reducerPath: "channelHistory",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,

  endpoints: (builder) => ({
    channelHistory: builder.query({
      query: ({id, page}) => {
        return {
          url: `v1/customers/actions/?contact=${id}&ordering=-created&page=${page}&page_size=5`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useChannelHistoryQuery } = ChannelHistory;